<!--
  Full view of the bank account overview (cr.CustomerBankAccount, TM-1000002030) - the wide variant of the one
  shared overview component. Shape of cp-provision-type-matrix-full.component.html.

  @ticket TM-1000002030
-->
@if (initialized && dto) {

    <div class="cr-customer-bank-account-overview-full w-full mt-4">

        <cr-customer-bank-account-overview
                [bankAccountId]="objectIdentifier.objectId"
                [compact]="false">
        </cr-customer-bank-account-overview>

    </div>

}
